/* eslint-disable no-return-assign */
/* eslint-disable no-param-reassign */
import axios from 'axios';
import { history } from '../App';
import { getCurrentUser, setCurrentUser } from '../helpers/Utils';

const instance = axios.create();
const endpoint = 'https://05ykj9ba8d.execute-api.ap-northeast-1.amazonaws.com/prod/';

instance.defaults.baseURL = endpoint;
instance.defaults.headers.common.Accept = "application/json";
instance.defaults.headers["Content-Type"] = "application/json";
instance.defaults.headers.post["Content-Type"] = "multipart/form-data";
instance.defaults.headers.put["Content-Type"] = "multipart/form-data";
instance.interceptors.request.use(async (config) => {
  config.headers.common["Access-Control-Allow-Origin"] = "*";
  config.headers.common["Access-Control-Allow-Headers"] =
    "Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token";
  config.headers.common["Access-Control-Allow-Credentials"] = true;
  config.headers.common["Access-Control-Allow-Method"] = "OPTIONS,POST,GET,PUT";
  config.headers.common.username = 'username';
  config.headers.common.access_token = 'xxxx_token';

  const currentUser = await getCurrentUser();
  if (currentUser) {
    config.headers.common.username = `${currentUser.Username}`;
    config.headers.common.access_token = `${currentUser.AccessToken}`;
  }

  return config;
});

const handleRefreshToken = async () => {
  const currentUser = await getCurrentUser();
  const refreshToken = currentUser?.RefreshToken;
  const refreshResult = await axios.get(`${endpoint}/auth/refresh`,
    {
      headers: { refresh_token: refreshToken },
    }
  );
  const AccessToken = refreshResult.data.access_token;
  const newUser = { ...currentUser, AccessToken };
  await setCurrentUser(newUser);
  return AccessToken;
};

instance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async (error) => {
    if (error.response.status === 404) {
      // return window.location.href = '/error';
    }
    if(error.response.status === 401) {
      const request = error.config;
      try {
        const AccessToken = await handleRefreshToken();
        request.headers.access_token = AccessToken;
        return await instance(request);
      } catch (err) {
        await setCurrentUser();
        history.push('/');
      }

      // localStorage.removeItem('current_user');
      // return window.location.reload();
    }
    return Promise.reject(error.response.data);
  }
);
export default instance;
